import React from 'react';
import { motion } from 'framer-motion';

const ServicesAdvertise = () => {
  return (
    <div className="min-h-screen  flex items-center justify-center p-4">
      <div className="max-w-6xl w-full flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
        
        {/* Left Side - Photographer Image */}
        <motion.div 
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="relative lg:pl-8"
        >
          <div className="rounded-3xl overflow-hidden relative max-w-md max-h-[600px] inline-block">
            {/* Real Photographer Image */}
            <motion.img
              initial={{ scale: 1.1, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.8 }}
              src="/images/Photographer.png"
              alt="Professional Photographer"
              className="w-auto h-auto max-w-full max-h-full object-contain"
            />
            
            {/* Optional overlay for better text contrast if needed */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent"></div>
          </div>
        </motion.div>

        {/* Right Side - Content */}
        <div className="flex-1 max-w-lg">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            {/* Main Heading */}
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-6 leading-tight">
              From photographers to Venues,{' '}
              <span className="text-orange-400">EventPlanly</span>{' '}
              has Best vendors for you to choose from.
            </h1>

            {/* Subheading */}
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Eventplanly recommend you personally curated list of venue options by experts specially for your requirements.
            </p>
          </motion.div>

          {/* Vendor Avatars */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="flex -space-x-2"
          >
            {/* Avatar 1 - Light Blue Background */}
            <motion.div
              whileHover={{ scale: 1.1, zIndex: 10 }}
              className="rounded-full bg-sky-300 flex items-center justify-center border-4 border-white shadow-lg relative z-0 p-1"
            >
              <img
                src="/images/Avatar 1.png" // Replace with your actual image path
                alt="Vendor 1"
                className="w-12 h-12 rounded-full object-cover"
              />
            </motion.div>

            {/* Avatar 2 - Purple Background */}
            <motion.div
              whileHover={{ scale: 1.1, zIndex: 10 }}
              className="rounded-full bg-purple-400 flex items-center justify-center border-4 border-white shadow-lg relative z-0 p-1"
            >
              <img
                src="/images/Avatar 2.png" // Replace with your actual image path
                alt="Vendor 2"
                className="w-12 h-12 rounded-full object-cover"
              />
            </motion.div>

            {/* Avatar 3 - Yellow Background */}
            <motion.div
              whileHover={{ scale: 1.1, zIndex: 10 }}
              className="rounded-full bg-yellow-300 flex items-center justify-center border-4 border-white shadow-lg relative z-0 p-1"
            >
              <img
                src="/images/Avatar 3.png" // Replace with your actual image path
                alt="Vendor 3"
                className="w-12 h-12 rounded-full object-cover"
              />
            </motion.div>

            {/* Avatar 4 - Purple Background */}
            <motion.div
              whileHover={{ scale: 1.1, zIndex: 10 }}
              className="rounded-full bg-purple-500 flex items-center justify-center border-4 border-white shadow-lg relative z-0 p-1"
            >
              <img
                src="/images/Avatar 4.png" // Replace with your actual image path
                alt="Vendor 4"
                className="w-12 h-12 rounded-full object-cover"
              />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ServicesAdvertise;